var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * Accordion component for collapsible content sections.
 *
 * ## Usage
 * ```html
 * <kr-accordion header="Basic Information" expanded>
 *   <div>Content here</div>
 * </kr-accordion>
 * ```
 *
 * @slot - The collapsible content
 *
 * @property {string} header - Section header text
 * @property {boolean} expanded - Whether the accordion is expanded
 */
export class KRAccordion extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Section header text
         */
        this.header = '';
        /**
         * Whether the accordion is expanded
         */
        this.expanded = false;
    }
    handleHeaderClick() {
        this.expanded = !this.expanded;
    }
    render() {
        return html `
      <div class="header" @click=${this.handleHeaderClick}>
        <span class="header__title">${this.header}</span>
        <svg
          class="header__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </div>
      <div class="content">
        <div class="content__inner">
          <div class="content__body">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
    }
}
KRAccordion.styles = css `
    :host {
      display: block;
      margin-bottom: 16px;
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background: #f7f8f9;
      border-radius: 8px;
      cursor: pointer;
      user-select: none;
    }

    .header__title {
      font-size: 15px;
      font-weight: 600;
      color: #111827;
    }

    .header__icon {
      width: 20px;
      height: 20px;
      color: #9ca3af;
      transition: transform 0.2s ease;
      flex-shrink: 0;
    }

    :host([expanded]) .header__icon {
      transform: rotate(180deg);
    }

    .content {
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.2s ease;
    }

    :host([expanded]) .content {
      grid-template-rows: 1fr;
    }

    .content__inner {
      overflow: hidden;
    }

    .content__body {
      padding: 16px 16px 8px 16px;
    }
  `;
__decorate([
    property({ type: String })
], KRAccordion.prototype, "header", void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true,
    })
], KRAccordion.prototype, "expanded", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell's global copy alongside an app's bundled copy) doesn't
// throw. First definition wins.
if (!customElements.get('kr-accordion')) {
    customElements.define('kr-accordion', KRAccordion);
}
//# sourceMappingURL=accordion.js.map